import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import LTVReportDownloadModal from "../../../components/modals/LTVReportDownloadModal";
import { useSelector, useDispatch } from "react-redux";
import { format } from "date-fns";
import {
  kpiReport,
  ltvReport,
  monthlyLending,
  commonErrMsg
} from "../../../locales/en";
import { showToast, getMaxDateByMonthOffset } from "../../../utils/utils";
import {
  showToastType,
  VIEW_OPTIONS_TYPE
} from "../../../utils/constants/appConstants";
import { getSalseLead } from "../../../redux/userSalesLeadPersonSlice";
import { getReferralData } from "../../../redux/referraPartnerSlice";
import {
  countries,
  customer_time_period,
  viewType,
  Referral_Type
} from "../../../utils/data/data";
import styles from "./../../../assets/scss/custom.module.scss";
import "react-datepicker/dist/react-datepicker.css";
import ".././reportStyle.scss";
import { dd_MMM_yyyy, ddmmyyyy } from "../../../utils/constants/appConstants";
import {
  getReferral,
  querter_periods,
  years_periods,
  monthly_time_period
} from "../../../utils/getDropdownOptions";

const LtvFilter = ({ ltvFilter, LTVloading, onInputChange }) => {
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState(
    ltvFilter.asAtDate ? new Date(ltvFilter.asAtDate) : new Date()
  );
  const maxDate = getMaxDateByMonthOffset();
  const [referralData, setReferralData] = useState([]);

  const { userSlaesLead } = useSelector((state) => state.userSalseLeadPerson);

  const [addLTVReportDownload, setAddLTVReportDownload] = useState(false);
  const toggleLTVReportDownload = () => {
    setAddLTVReportDownload(!addLTVReportDownload);
  };

  const handleDateChange = (date) => {
    setStartDate(date);
    onInputChange({
      target: {
        name: "asAtDate",
        value: date ? date.toISOString() : ""
      }
    });
  };

  useEffect(() => {
    const getSalseLeadData = async () => {
      await dispatch(getSalseLead()).unwrap();
    };
    getSalseLeadData();
  }, []);

  useEffect(() => {
    if (ltvFilter.asAtDate) {
      setStartDate(
        ltvFilter.asAtDate ? new Date(ltvFilter.asAtDate) : new Date()
      );
    }
  }, [ltvFilter.asAtDate]);

  useEffect(() => {
    const fetchReferralPartner = async () => {
      try {
        const response = await dispatch(getReferralData()).unwrap();
        setReferralData(response?.data?.data);
      } catch {
        showToast(commonErrMsg.item2, showToastType.error);

        setReferralData([]);
      }
    };
    fetchReferralPartner();
  }, []);

  const preventManualInput = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <div className="col-md-4 d-flex align-items-center mb-1 mt-1">
        <div className="col-12 d-flex">
          <div className="col-5 d-flex">
            <label htmlFor="view" className={`${styles.selectStatusLabel}`}>
              {kpiReport?.filter.viewTye}
            </label>
          </div>
          <div className="col-7 d-flex">
            <select
              name="viewType"
              className={`${styles.selectShowStatus} pe-5`}
              value={ltvFilter.viewType}
              onChange={onInputChange}
              disabled={LTVloading}
            >
              {viewType.map((filter) => (
                <option key={filter.id} value={filter.value}>
                  {filter.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="col-md-4 d-flex align-items-center mb-1 mt-1">
        <div className="col-12 d-flex">
          <div className="col-5 d-flex">
            <label
              htmlFor="Status-sort"
              className={`${styles.selectStatusLabel} d-flex align-self-center `}
            >
              {kpiReport?.filter.period}
            </label>
          </div>
          <div className="col-7 d-flex">
            <select
              name="period"
              className={`${styles.selectShowStatus}`}
              value={ltvFilter?.period}
              onChange={onInputChange}
              disabled={LTVloading}
            >
              {ltvFilter.viewType === VIEW_OPTIONS_TYPE?.MONTH && (
                <>
                  {monthly_time_period.map((filter) => (
                    <option key={filter.id} value={filter.value}>
                      {filter.value}
                    </option>
                  ))}
                </>
              )}
              {ltvFilter.viewType === VIEW_OPTIONS_TYPE?.QUARTER && (
                <>
                  {querter_periods.map((filter) => (
                    <option key={filter.id} value={filter.value}>
                      {filter.name}
                    </option>
                  ))}
                </>
              )}
              {ltvFilter.viewType === VIEW_OPTIONS_TYPE?.YEAR && (
                <>
                  {years_periods.map((filter) => (
                    <option key={filter.id} value={filter.value}>
                      {filter.name}
                    </option>
                  ))}
                </>
              )}
            </select>
          </div>
        </div>
      </div>

      <div className="col-md-4 d-flex align-items-center mb-1 mt-1">
        <div className="col-12 d-flex">
          <div className="col-5 d-flex">
            <label
              htmlFor="Status-sort"
              className={`${styles.selectStatusLabel} d-flex align-self-center `}
            >
              {ltvReport?.filter.country}
            </label>
          </div>
          <div className="col-7 d-flex">
            <select
              name="country"
              className={`${styles.selectShowStatus}`}
              value={ltvFilter.country}
              onChange={onInputChange}
              disabled={LTVloading}
            >
              {countries.map((filter) => (
                <option key={filter.id} value={filter.value}>
                  {filter.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="col-md-4 d-flex align-items-center mb-1 mt-1">
        <div className="col-12 d-flex">
          <div className="col-5 d-flex">
            <label
              htmlFor="Status-sort"
              className={`${styles.selectStatusLabel} d-flex align-self-center `}
            >
              {ltvReport?.filter.customer}
            </label>
          </div>
          <div className="col-7 d-flex">
            <select
              name="customerDuration"
              className={`${styles.selectShowStatus}`}
              value={ltvFilter.customerDuration}
              onChange={onInputChange}
              disabled={LTVloading}
            >
              {customer_time_period.map((filter) => (
                <option key={filter.id} value={filter.value}>
                  {filter.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="col-md-4 d-flex align-items-center mb-1 mt-1">
        <div className="col-12 d-flex">
          <div className="col-5 d-flex">
            <label
              htmlFor="Status-sort"
              className={`${styles.selectStatusLabel} d-flex align-self-center `}
            >
              {ltvReport?.filter.salesLead}
            </label>
          </div>
          <div className="col-7 d-flex">
            <select
              name="salesLeadName"
              className={`${styles.selectShowStatus}`}
              value={ltvFilter.salesLeadName}
              onChange={onInputChange}
              disabled={LTVloading}
            >
              <option value="">{monthlyLending?.filter?.all}</option>
              {userSlaesLead.map((filter) => (
                <option key={filter.id} value={filter.id}>
                  {filter.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="col-md-4 d-flex align-items-center mb-1 mt-1">
        <div className="col-12 d-flex">
          <div className="col-5 d-flex">
            <label
              htmlFor="Status-sort"
              className={`${styles.selectStatusLabel} d-flex align-self-center`}
            >
              {kpiReport?.filter.referral}
            </label>
          </div>
          <div className="col-7 d-flex">
            <select
              name="referralType"
              className={`${styles.selectShowStatus}`}
              value={ltvFilter.referralType}
              onChange={onInputChange}
              disabled={LTVloading}
            >
              {getReferral().map((filter) => (
                <option key={filter.id} value={filter.value}>
                  {filter.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="col-md-4 d-flex align-items-center mb-1 mt-1">
        <div className="col-12 d-flex">
          <div className="col-5 d-flex">
            <label
              htmlFor="Status-sort"
              className={`${styles.selectStatusLabel} d-flex align-self-center `}
            >
              {kpiReport?.filter.referralType}
            </label>
          </div>
          <div className="col-7 d-flex">
            <select
              name="referralSubType"
              className={`${styles.selectShowStatus}`}
              value={ltvFilter.referralSubType}
              onChange={onInputChange}
              disabled={LTVloading}
            >
              {Referral_Type.map((filter) => (
                <option key={filter.id} value={filter.value}>
                  {filter.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="col-md-4 d-flex align-items-center mb-1 mt-1">
        <div className="col-12 d-flex">
          <div className="col-5 d-flex">
            <label
              htmlFor="Status-sort"
              className={`${styles.selectStatusLabel} d-flex align-self-center `}
            >
              {ltvReport?.filter.refParter}
            </label>
          </div>
          <div className="col-7 d-flex">
            <select
              name="referralPartnerName"
              className={`${styles.selectShowStatus}`}
              value={ltvFilter.referralPartnerName}
              onChange={onInputChange}
              disabled={LTVloading}
            >
              <option value="">{monthlyLending?.filter?.all}</option>
              {referralData?.map((filter) => (
                <option key={filter.id} value={filter.id}>
                  {filter.fullName}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="col-md-4 d-flex flter_datepicker mb-1 mt-1 ">
        <div className="col-12 d-flex">
          <div className="col-5">
            <label
              className={`${styles.selectStatusLabel} d-flex align-self-center `}
            >
              {ltvReport?.filter.asDate}
            </label>
          </div>
          <div className="col-7 d-flex">
            <DatePicker
              selected={startDate}
              onChange={handleDateChange}
              placeholderText={ddmmyyyy}
              dateFormat={dd_MMM_yyyy}
              popperPlacement="bottom-end"
              portalId="root"
              maxDate={maxDate}
              customInput={
                <input
                  type="text"
                  value={startDate ? format(startDate, dd_MMM_yyyy) : ""}
                  readOnly
                />
              }
              disabled={LTVloading}
              onKeyDown={preventManualInput}
              onChangeRaw={preventManualInput}
            />
          </div>
        </div>
      </div>

      <LTVReportDownloadModal
        isOpen={addLTVReportDownload}
        toggle={toggleLTVReportDownload}
      />
    </>
  );
};
LtvFilter.propTypes = {
  ltvFilter: PropTypes.object,
  LTVloading: PropTypes.bool,
  onInputChange: PropTypes.func
};

export default LtvFilter;
